export enum EventsEnum {
  // ---------- Root Events ----------
  // Core
  Started = 'started',
  Loaded = 'loaded',
  Tick = 'tick',

  // Human
  HumanReady = 'human.ready',
  HumanStarted = 'started',
  Error = 'error',
  HumanError = 'human.error',
  // ---------- Namespaced Events ----------
  // Annotations
  AnnotationsCreated = 'annotations.created',
  AnnotationsDestroyed = 'annotations.destroyed',
  AnnotationsHidden = 'annotations.hidden',
  AnnotationsShown = 'annotations.shown',

  // Assets
  AssetsLoadFinish = 'assets.load.finish',
  AssetsLoadProgress = 'assets.load.progress',
  AssetsLoadStart = 'assets.load.start',

  // Camera
  CameraRested = 'camera.rested',
  CameraUpdated = 'camera.updated',

  // Hotspots
  HotspotsDisplayUpdated = 'hotspots.displayUpdated',
  HotspotsEntered = 'hotspots.entered',
  HotspotsLeft = 'hotspots.left',
  HotspotsPicked = 'hotspots.picked',
  HotspotsPositionUpdated = 'hotspots.positionUpdated',

  // Labels
  LabelCreated = 'label.created',
  LabelDestroyed = 'label.destroyed',
  LabelsDestroyed = 'label.destroyed',
  LabelsHidden = 'labels.hidden',
  LabelsShown = 'labels.shown',

  // Modules
  ModuleInteractive = 'module.interactive',
  ModulesActivateFinish = 'modules.activate.finish',
  ModulesCreateFinish = 'modules.create.finish',
  ModulesDestroyFinish = 'modules.destroy.finish',

  // Pick
  PickPicked = 'pick.picked',

  // Scene
  SceneMarkersUpdated = 'scene.markers.updated',
  SceneObjectRenderable = 'scene.objectRenderable',
  SceneObjectsSelected = 'scene.objectsSelected',
  SceneObjectsShown = 'scene.objectsShown',
  ScenePicked = 'scene.picked',
  SceneRestored = 'scene.restored',
  SceneXrayEnabled = 'scene.xrayEnabled',
  SceneXrayDisabled = 'scene.xrayDisabled',
  
  // internal only - used because the API lib only fires human.ready once, even though we can do things like scene.load()
  Debug_SceneReady = 'debug.scene.ready', 

  // Timeline
  TimelineChaptersActivated = 'timeline.chapters.activated',
  TimelineChaptersActivateFinish = 'timeline.chapters.activate.finish',
  TimelineChaptersActivateStart = 'timeline.chapters.activate.start',
  TimelineChapterTransition = 'timeline.chapterTransition',
  TimelinePlaying = 'timeline.playing',
  TimelineScrubbed = 'timeline.scrubbed',
  TimelinePlayed = 'timeline.played',
  TimelineStopped = 'timeline.stopped',
  TimelinePaused = 'timeline.paused',
  TimelineUnpaused = 'timeline.unpaused',
  TimelineCompleted = 'timeline.completed'
}
